import { gql } from '@apollo/client';
import { NewClusterInput } from 'views/Warehouses/hooks/useCreateCluster';

const createRedshiftCluster = (
    environmentUri: string,
    input: NewClusterInput,
) => {
    const clusterInput = {
        ...input,
        numberOfNodes: parseInt(input.numberOfNodes),
    };
    return {
        variables: {
            environmentUri,
            clusterInput,
        },
        mutation: gql`
            mutation createRedshiftCluster(
                $environmentUri: String!
                $clusterInput: NewClusterInput!
            ) {
                createRedshiftCluster(
                    environmentUri: $environmentUri
                    clusterInput: $clusterInput
                ) {
                    clusterUri
                    name
                    label
                    created
                }
            }
        `,
    };
};

export default createRedshiftCluster;
